import HeardContainer from "../components/heardContainer";
import kf03 from "../assets/img/kf03.jpg"
import kf04 from "../assets/img/kf04.jpg"
import ai from "../assets/gif/ai.gif"

export default function HaimaAI () {
    document.title = '海马AI客服系统'
    const keyword = document.querySelector('meta[name="keyword"]')
    keyword.setAttribute('content', '海马客服、客服系统、私有化部署、独立部署、全渠道支持')
    const description = document.querySelector('meta[name="description"]')
    description.setAttribute('content', '一体化多渠道客户服务解决方案，集行业AI智能客服机器人与云客服系统于一体。支持全渠道接入，兼容文本、图片、语音、视频等多种消息形式。访客来源与历史交互数据全方位呈现，助力高效智能客户管理。')
    return (
        <div className="bg-gradient-radial from-[#7b61ff]/10 via-transparent to-[#070814] text-[#eaf5ff] font-sans">
            <div className="max-w-6xl mx-auto p-7">
                <HeardContainer tilte="海马AI客服" subtitle="一体化客户联络服务平台 · 智能+人工协同" />
                <section className="max-w-6xl mx-auto grid md:grid-cols-2 gap-5">
                    <div className="bg-[#ffffff]/5 p-5 rounded-2xl backdrop-blur-sm shadow-[0_10px_30px_rgba(2,6,23,0.6)]">
                        <div className="flex items-center gap-3">
                            <h2 className="text-lg">海马AI客服 ❤️智能应答 · 多渠道接入❤️</h2>
                        </div>
                        <p className="text-[#eaf5ff]/60 mb-8">融合智能机器人、知识库、人工坐席，多语言AI智能翻译，支持网页/移动端/H5/嵌入式等多渠道统一接入。</p>

                        <div className="flex flex-col gap-3">
                            <div className="flex gap-3 items-start">
                                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#7b61ff] to-[#00d4ff] flex items-center justify-center font-bold">📚</div>
                                <div>
                                    <h3 className="text-sm font-semibold">知识库驱动</h3>
                                    <p className="text-[#eaf5ff]/60 text-sm">自动检索与推荐答案，支持文档/FAQ/多轮问答。</p>
                                </div>
                            </div>

                            <div className="flex gap-3 items-start">
                                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#7b61ff] to-[#00d4ff] flex items-center justify-center font-bold">🤖</div>
                                <div>
                                    <h3 className="text-sm font-semibold">智能机器人</h3>
                                    <p className="text-[#eaf5ff]/60 text-sm">意图识别、槽位抽取与对话管理，支持无缝转人工。</p>
                                </div>
                            </div>

                            <div className="flex gap-3 items-start">
                                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#7b61ff] to-[#00d4ff] flex items-center justify-center font-bold">🤵</div>
                                <div>
                                    <h3 className="text-sm font-semibold">人工坐席台</h3>
                                    <p className="text-[#eaf5ff]/60 text-sm">单窗口多窗口客服个人自由设置，高效工作，响应提速，体验升级。</p>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-3 gap-4 mt-8">
                            <div className="p-4 rounded-xl bg-[#ffffff]/5 border border-[#ffffff]/2">
                                <h4 className="text-sm font-semibold">多平台接入</h4>
                                <p className="text-[#eaf5ff]/60 text-sm">一套客服，解决多个平台客服需求问题，每个平台都可以进行独立配置</p>
                            </div>
                            <div className="p-4 rounded-xl bg-[#ffffff]/5 border border-[#ffffff]/2">
                                <h4 className="text-sm font-semibold">智能路由</h4>
                                <p className="text-[#eaf5ff]/60 text-sm">基于意图与技能的自动分配，支持优先级与SLA策略。</p>
                            </div>
                            <div className="p-4 rounded-xl bg-[#ffffff]/5 border border-[#ffffff]/2">
                                <h4 className="text-sm font-semibold">实时监督</h4>
                                <p className="text-[#eaf5ff]/60 text-sm">实时监控会话、客服响应情况、对话内容质量。</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-gradient-to-b from-[#061022] to-[#081226] p-3 rounded-xl backdrop-blur-sm border border-white/10 h-[38rem] overflow-hidden">
                        <div>
                            <p className="text-[#ffffff99] mt-2">
                                <span className="text-white">✅</span>一套客服，解决多个平台客服需求问题<br />
                                <span className="text-white">✅</span>每个平台都可以进行独立配置<br />
                                <span className="text-white">✅</span>参数带入，减少基础信息询问，提升高作效率，提高服务品质
                            </p>
                            <div className="flex mt-2 h-[190px]">
                                 <img src={kf04} className="mr-2" alt="海马AI客服系统" />
                                <img src={kf03} alt="海马AI客服系统" />
                            </div>
                        </div>
                        <div>
                            <p className="text-[#ffffff99] mt-4"> <span className="text-white">✅</span>单窗口多窗口客服个人自由设置，高效工作，响应提速，体验升级。</p>
                            <img className="mt-2" src={ai} alt="海马AI客服系统" />
                        </div>
                    </div>
                </section>

                <footer className="mt-8 text-[#eaf5ff]/60 text-sm text-center">
                    <div>适配中小企业与企业级客户 · 支持私有部署与云端SaaS</div>
                    <div className="relative mt-4">
                        <div className="absolute left-1/2 -translate-x-1/2 inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-[2px] w-3/4 blur-sm" />
                        <div className="absolute left-1/2 -translate-x-1/2 inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-px w-3/4" />
                        <div className="absolute left-1/2 -translate-x-1/2 inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-[5px] w-1/4 blur-sm" />
                        <div className="absolute left-1/2 -translate-x-1/2 inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px w-1/4" />
                    </div>
                </footer>
            </div>
        </div>
    );
}
